import React from "react";
import translate from "../../constants/translations";

interface ConversationClosedInformationProps {
	cultureCode: string;
}

export default function ConversationClosedInformation({
	cultureCode,
}: ConversationClosedInformationProps) {
	return (
		<div className="if u-padding-sm-left--64 u-padding-sm-right--64">
			<div className="if text center lead">
				{translate(cultureCode, "ConversationClosedHeaderText")}
			</div>
			<div className="if text center u-margin-top--smaller">
				{translate(cultureCode, "ConversationClosedInformationText")}
			</div>
		</div>
	);
}
